import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setReturnUnboxingVideo = {
  name: "setReturnUnboxingVideo" as const,
  input: z.object({
    returnId: zExt.objectId(),
    key: z
      .string()
      .describe("S3 object key returned by getUnboxingVideoUploadUrl"),
  }),
  output: z.object({ success: z.boolean() }),
};
